export default "__VITE_ASSET__Chsb6Jqx__"